export default __webpack_public_path__ + "static/media/0x87f654c4b347230c60cad8d7ea9cf0d7238bcc79.ec8fd8d6.svg";